import updateSnackbarMessage from "./updateSnackbarMessage";
import { postData } from "../API/Post";

export default async function importData(
  setResults,
  setImporting,
  file,
  type,
  establishmentId,
  deviceType,
  t
) {
  setResults(null);
  setImporting(true);

  if (!file) {
    updateSnackbarMessage(t("common.no_file_selected"));
    setImporting(false);
    return;
  }

  if (!establishmentId && type === "residences") {
    updateSnackbarMessage(t("common.no_establishment_selected"));
    setImporting(false);
    return;
  }

  if (!deviceType && type === "meters") {
    updateSnackbarMessage(t("common.no_device_type_selected"));
    setImporting(false);
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  if (type === "meters") {
    formData.append("device_brand_id", deviceType);
  } else if (type === "residences") {
    formData.append("establishment_id", establishmentId);
  }

  // Map type to API endpoint
  const endpoint = type === "update-keys" ? "/import/update-keys" : "/import/" + type;

  try {
    const result = await postData(endpoint, formData);

    if (result && result.data) {
      setResults(result.data);
    } else if (result && result.response) {
      updateSnackbarMessage(
        result.response.data?.detail || t("common.import_failed")
      );
    } else {
      updateSnackbarMessage(t("common.import_failed"));
    }
  } catch (error) {
    updateSnackbarMessage(t("common.import_failed"));
  } finally {
    setImporting(false);
  }
}
